import React, { forwardRef } from "react";
import MuiPopper, { type PopperProps } from "@material-ui/core/Popper";

import { useFullscreenElement } from "src/utils/fullscreen";

export type { PopperProps };

/** This is just a wrapper of Mui's Popper that patches `container` property to make
 * the popper work in fullscreen mode.
 */
const Popper = forwardRef<HTMLDivElement, PopperProps>(
  (props: PopperProps, ref) => {
    const fullscreenElement = useFullscreenElement();

    return (
      <MuiPopper
        ref={ref}
        container={fullscreenElement || document?.body}
        {...props}
      />
    );
  }
);

export default Popper;
